export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS = {
  pending: { label: "Neue Anfrage", dot: "bg-yellow-400", chip: "bg-yellow-400/15 border-yellow-400/60 text-yellow-200", text: "text-yellow-300" },
  confirmed: { label: "Bestätigt", dot: "bg-green-500", chip: "bg-green-500/15 border-green-500/60 text-green-200", text: "text-green-400" },
  cancelled: { label: "Abgesagt", dot: "bg-red-500", chip: "bg-red-500/10 border-red-500/50 text-red-300 line-through decoration-red-400/60", text: "text-red-400" },
  cancelled_customer: { label: "Vom Kunden abgesagt", dot: "bg-red-400", chip: "bg-red-500/10 border-red-400/50 text-red-300 line-through decoration-red-400/60", text: "text-red-300" },
  completed: { label: "Abgeschlossen", dot: "bg-zinc-500", chip: "bg-zinc-500/15 border-zinc-500/50 text-zinc-300", text: "text-zinc-400" },
  alternative: { label: "Alternative vorgeschlagen", dot: "bg-orange-500", chip: "bg-orange-500/15 border-orange-500/60 text-orange-200", text: "text-orange-400" },
};

export const TRAINING_TYPES = [
  { id: "einzeltraining_kind", name: "Einzeltraining Kind" },
  { id: "einzeltraining_erwachsen", name: "Einzeltraining Erwachsen" },
  { id: "torwarttraining", name: "Torwarttraining" },
  { id: "gruppentraining_2_4", name: "Gruppentraining (2-4 Spieler)" },
  { id: "gruppentraining_5_plus", name: "Gruppentraining (ab 5 Spieler)" },
];

export const WEEKDAYS_SHORT = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
export const WEEKDAYS = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];

export const todayBerlin = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Berlin" }).format(new Date());

export const parseISO = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };
export const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const addDays = (s, n) => { const d = parseISO(s); d.setDate(d.getDate() + n); return toISO(d); };
export const weekdayIdx = (s) => (parseISO(s).getDay() + 6) % 7;
export const startOfWeek = (s) => addDays(s, -weekdayIdx(s));
export const fmtDate = (s) => (s ? s.split("-").reverse().join(".") : "");
export const fmtDateLong = (s) => (s ? `${WEEKDAYS[weekdayIdx(s)]}, ${fmtDate(s)}` : "");
export const fmtDateTime = (iso) => {
  if (!iso) return "–";
  return new Intl.DateTimeFormat("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }).format(new Date(iso));
};
export const toMin = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };
export const euro = (v) => `${Number(v || 0).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const authHeaders = (token, json = false) => ({ "X-Admin-Token": token, ...(json ? { "Content-Type": "application/json" } : {}) });

export async function apiCall(token, path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, { method, headers: authHeaders(token, !!body), body: body ? JSON.stringify(body) : undefined });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401) window.dispatchEvent(new CustomEvent("admin-auth-expired", { detail: data?.detail }));
    const err = new Error(typeof data.detail === "string" ? data.detail : "Aktion fehlgeschlagen");
    err.status = res.status;
    throw err;
  }
  return data;
}

// The slot the appointment currently occupies in the calendar
export const eventSlot = (e) => (e.status === "alternative_proposed" && e.alternative ? e.alternative : e);

export const playerLabel = (e) => (e.player_name && e.player_name !== e.customer?.name ? e.player_name : null);
